import { useMemo, useCallback } from 'react';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';
import { cn } from '@/libs/utils';
import { transformWord } from '@/utils/filterUtils';

export default function TableHeaderSort({ dataIndex }) {
  const index = transformWord(dataIndex);
  const { queryParams, setQueryParams } = useQueryParamsContext();

  const currentSort = useMemo(() => {
    return queryParams[index] || null;
  }, [index, queryParams]);

  const handleSort = useCallback(() => {
    let nextSort = null;

    if (currentSort === null) {
      nextSort = 'asc';
    } else if (currentSort === 'asc') {
      nextSort = 'desc';
    }

    setQueryParams({
      ...queryParams,
      [index]: nextSort,
    });
  }, [currentSort, index, queryParams, setQueryParams]);

  return (
    <Button
      type="default"
      onClick={handleSort}
      className={cn(
        'btn-default !align-center grid !h-max p-0 px-0.5',
        currentSort ? 'bg-white text-accent shadow-md' : 'bg-transparent'
      )}
    >
      <div className="grid">
        <CaretUpOutlined
          className={cn(
            'relative top-0.5 scale-[0.8] text-[10px] text-sm text-zinc-400',
            currentSort === 'asc' ? '!text-accent' : ''
          )}
        />

        <CaretDownOutlined
          className={cn(
            'relative bottom-0.5 scale-[0.8] text-[10px] text-sm text-zinc-400',
            currentSort === 'desc' ? '!text-accent' : ''
          )}
        />
      </div>
    </Button>
  );
}
